import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table bonus report view.
 */
export default class recordTableBonusReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for advanced filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for displaying details
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'detailTittle',
                        header: '',
                        width: 50,
                        height: 25,
                        tooltip: _('Detalles'), // Tooltip for details
                        template: function (obj) {
                            return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                        },
                    },
                    { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                    { id: 'Type', header: _('Tipo'), width: 150, sort: 'int' }, // Type column
                    {
                        id: 'Amount',
                        header: _('Monto'), // Amount column
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'), // Description column
                        width: 150,
                        sort: 'int',
                    },
                ],
                onClick: {
                    details: function (euv, id) {
                        var item = this.getItem(id); // Get the clicked item
                        vthis.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with selected item
                        $$('detailsCasino').show(); // Show details for the selected item
                    },
                },
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            scrollY: screen.width < 820 ? false : true, // Conditional scroll based on screen width
            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
            columns: [
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: _('Detalles'), // Tooltip for details
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                { id: 'Type', header: _('Tipo'), width: 150, sort: 'int' }, // Type column
                {
                    id: 'Amount',
                    header: _('Monto'), // Amount column
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Description column
                    width: 150,
                    sort: 'int',
                },
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with selected item
                    $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                },
            },
            tooltip: true, // Enable tooltips
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'es/Report/GetClientBonusReportDetail'; // API URL for fetching report details
        this.on(this.app, 'user:id', (idUser) => {
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?id=' + idUser); // Load new data based on user ID
            $$('dtDetails').clearAll(); // Clear details data
            $$('dtDetails').load(url + '?id=' + idUser); // Load details data based on user ID
        });
    }
}

// FILE DOCUMENTED
